import GSAP from 'gsap'
import { EventEmitter } from 'events'

export default class Preloader extends EventEmitter {
  constructor({ selector, counter, logo }) {
    super()
    //
    this.selector =
      selector instanceof window.HTMLElement ? selector : document.querySelector(selector)
    this.counter = counter instanceof window.HTMLElement ? counter : document.querySelector(counter)
    this.logo = logo instanceof window.HTMLElement ? logo : document.querySelector(logo)
    this.length = 0
    this.imgArray = document.querySelectorAll('img')
    this.videoArray = document.querySelectorAll('video')

    //Methodes
    this.imgArray.length ? this.createLoader() : this.onLoaded()
  }

  createLoader() {
    this.videoArray.forEach((video) => {
      // console.log(img.src)
      // const video = document.createElement('video')
      // video.src = vid.src
      // video.autoplay = true
      video.addEventListener('canplaythrough', () => console.log('video loaded'), false)
    })

    this.imgArray.forEach((img) => {
      // console.log(img.src)
      const media = new window.Image()
      media.src = img.src
      media.onload = () => this.onAssetLoaded()
    })
  }

  onAssetLoaded() {
    this.length += 1

    const percent = this.length / this.imgArray.length
    // console.log(this.length, this.imgArray.length, Math.round(percent * 100))

    this.counter.innerHTML = `${Math.round(percent * 100)}%`
    if (percent === 1) {
      this.onLoaded()
    }
  }

  onLoaded() {
    this.tl = GSAP.timeline({
      delay: 1,
    })

    this.tl.to([this.logo, this.counter], {
      autoAlpha: 0,
      duration: 1,
      ease: 'Power2.easeOut',
      stagger: 0.2,
    })

    this.tl.to(this.selector, {
      autoAlpha: 0,
      duration: 1,
      // y :'100%',
      ease: 'Power2.easeOut',
    })

    this.tl.call(() => {
      this.emit('completed')
      document.querySelector('html').classList.add('isReady')
      this.destroy()

      // this.animateElements()
    })
  }

  // animateElements() {
  //   this.animateHeader()
  // }

  // animateHeader() {
  //   this.headerAnimation = GSAP.timeline({
  //     delay: 0
  //   })

  //   this.header = document.querySelector('header')
  //   this.logoWrapper = document.querySelector('.header__logo')
  //   this.rsWrapper = document.querySelector('.header__rs')
  //   this.nav = document.querySelectorAll('.header__nav li')

  //   this.headerAnimation.fromTo(this.header, {
  //     autoAlpha: 0,
  //     y: '-100%'
  //   }, {
  //     autoAlpha: 1,
  //     y: 0
  //   }, 'start')

  //   this.headerAnimation.fromTo(this.logoWrapper, {
  //     x: '-100%'
  //   }, {
  //     autoAlpha: 1,
  //     x: 0
  //   }, 'start+=0.5')

  //   this.headerAnimation.fromTo(this.rsWrapper, {
  //     x: '100%'
  //   }, {
  //     autoAlpha: 1,
  //     x: 0
  //   }, 'start+=0.5')

  //   this.headerAnimation.fromTo(this.nav, {
  //     y: '-30',

  //   }, {
  //     autoAlpha: 1,
  //     y: 0,
  //     stagger: 0.03
  //   })

  // }

  destroy() {
    this.selector.parentNode.removeChild(this.selector)
  }
}
